import { render, staticRenderFns } from "./EditAdressesDialog.vue?vue&type=template&id=4602371a&"
import script from "./EditAdressesDialog.vue?vue&type=script&lang=ts&"
export * from "./EditAdressesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports